module.exports = __webpack_public_path__ + "static/img/8.1c8c0b43.jpg";